export const MARKETING_SITE_URL = "https://vincimindlabs.com";
export const APP_URL = "https://app.vincimindlabs.com";
